module.exports = __webpack_public_path__ + "static/media/icon14.3dc49d57.svg";